import { useEffect, useState } from "react";

export default () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [isXSView, setIsXSView] = useState(true);

  useEffect(() => {
    function handleResize() {
      setIsXSView(window.innerWidth <= 575)
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return {isXSView};
}